const servers = 20332;
const capacity = 23788.44;
const countries = 148;
const locations = 194;
export { servers, capacity, countries, locations };
